import SettingsIcon from '@mui/icons-material/Settings'

import AdvancedBooleanField from '../AdvancedBooleanField'
import CircularGaugeIcon from '../CircularGaugeIcon'
import UnitField from '../UnitField'
import FieldRow from './FieldRow'

const EngineField = ({ engine_running, rpm }) => (
  <FieldRow
    icon={
      <CircularGaugeIcon
        thresholds={[
          { limit: 0, color: '#757575', label: 'engine.state.off' },
          { limit: 800, color: '#757575', label: 'engine.state.idle' },
          { limit: 2500, color: '#1fd92e', label: 'engine.state.normal' },
          { limit: 4000, color: '#ed6c02', label: 'engine.state.high' },
          { limit: Infinity, color: '#d32f2f', label: 'engine.state.critical' },
        ]}
        Icon={SettingsIcon}
        value={engine_running ? rpm : 0}
      />
    }
  >
    {engine_running ? (
      <UnitField source="extra_data.engine_rpm" unit="rpm" />
    ) : (
      <AdvancedBooleanField source="engine_running" falseLabel="Off" trueLabel="On" trueIcon={null} falseIcon={null} />
    )}
  </FieldRow>
)

export default EngineField
